import React from 'react'
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../redux/app/hooks';
import { STUDENT_ROLE, VIRTUAL } from '../utils/constants';

interface PrivateRouteProps{
    children: any
}
const PrivateRoute: React.FC<PrivateRouteProps> = ({children}) => {
  const accessToken =localStorage.getItem(Object.keys(localStorage).find((key) => key.includes('accessToken')) as string) || null;
  const role = useAppSelector((state) => state.auth.role);
  const schoolType = useAppSelector((state) => state.auth.schoolType);
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  const teacherMainRoute: any = useAppSelector(
    (state) => state.auth.teacherMainRoute
  );

  if (accessToken) {
    if (role === STUDENT_ROLE && (schoolType === VIRTUAL || selectedClassRoomId)) {
      return children;
    } else if (role === STUDENT_ROLE) {
      return <Navigate to="/virtual-school/virtual-student-login" replace />;
    } else if (role !== STUDENT_ROLE) {
      return children;
    }
  } else {
    return <Navigate to="/" replace />;
  }
}

export default PrivateRoute
